var marketSelector = {
	selectionLabel: "Seleccione un Mercado"
};
var es = {
	marketSelector: marketSelector
};

export { es as default, marketSelector };
